import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 3V0H19V3H16V5H19V8H21V5H24V3H21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 9.5C20.9002 9.5 21.7499 9.28372 22.5 8.90029V18H6.87574L1.5 22.7038V2H14.8749C14.6329 2.61986 14.5 3.29442 14.5 4C14.5 7.03757 16.9624 9.5 20 9.5Z"}}]};

const ChatAddFilled = Vue.extend<IconProps>({
  name: 'ChatAddFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chat-add-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChatAddFilled;
